module.exports = __webpack_public_path__ + "img/hr-steam-turbine-V-shadow.b60e2dca.png";